const VideoImage = ({ src, alt, onClick }) => (
  <div className="c-video-image" onClick={onClick} role="presentation">
    <img src={src} alt={alt} />
  </div>
);

export default VideoImage;
